import { render, staticRenderFns } from "./RefundPolicy.vue?vue&type=template&id=a195b42e&scoped=true"
import script from "./RefundPolicy.vue?vue&type=script&lang=js"
export * from "./RefundPolicy.vue?vue&type=script&lang=js"
import style0 from "./RefundPolicy.vue?vue&type=style&index=0&id=a195b42e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../.npm/_npx/14f5bcddd9f17f34/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a195b42e",
  null
  
)

export default component.exports